import { ContentMessage } from 'axway-react-ui';
import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import IntlComponent from 'axway-react-intl';

class DeleteEndpointDialog extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
		this.closeDialog = this.closeDialog.bind(this);
		this.deleteEndpoint = this.deleteEndpoint.bind(this);
	}
	closeDialog() {
		this.props.closeDialog();
	}
	deleteEndpoint() {
		this.props.deleteEndpoint();
	}

	render() {
		if (!this.props.endpointToDelete) {
			return null;
		}
		return (
			<ContentMessage
				confirm
				actionClass="btn-primary"
				onClose={this.closeDialog}
				summary={this.intl.formatMsg('Are you sure you want to delete this endpoint?')}
				className="lg warning generate-endpoints warning"
				imgClass="gg icon-GG-warning"
				onAction={this.deleteEndpoint}
				actionLabel={this.intl.formatMsg('Proceed')}
				cancelLabel={this.intl.formatMsg('Cancel')}
			/>
		);
	}
}

DeleteEndpointDialog.propTypes = {
	endpointToDelete: PropTypes.object,
	closeDialog: PropTypes.func.isRequired,
	deleteEndpoint: PropTypes.func.isRequired
};

DeleteEndpointDialog.defaultProps = {
	endpointToDelete: null
};

export default injectIntl(DeleteEndpointDialog);
